import React from 'react'

import labelClasses from './labelClasses'

export const LocationInfoFieldset = ({ bindAddress, formErrors }) => {
  const addressClasses = labelClasses(formErrors.address)
  return (
    <fieldset>
      
      <div className="input">
        <label htmlFor="address" className={addressClasses}>Address</label>
        <input required = {true} readOnly = {true} type="text" {...bindAddress} />
        <small>{formErrors.address}</small>
      </div>
    </fieldset>
  )
}

export default LocationInfoFieldset
